export const FREE_TEXT = "freeText";
export const DROPDOWN = "dropdown";
export const SPECIFIED = "specifiedJobType";
